import React, { useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { products } from '../utils/data';
import { CartContext } from '../App';
import { ShoppingCartIcon, ArrowLeftIcon, CheckIcon } from 'lucide-react';
export function ProductDetail() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const {
    addToCart
  } = useContext(CartContext);
  const [showAddedMessage, setShowAddedMessage] = useState(false);
  // Find the product based on the id from URL params
  const product = products.find(p => p.id === Number(id));
  // Handle case where product is not found
  if (!product) {
    return <div className="container mx-auto px-4 py-16 text-center" data-id="element-231">
        <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-232">
          Product Not Found
        </h2>
        <p className="text-gray-600 mb-8" data-id="element-233">
          The product you're looking for doesn't exist or has been removed.
        </p>
        <button onClick={() => navigate('/')} className="px-6 py-3 bg-green-600 text-white font-medium rounded-full hover:bg-green-700 transition" data-id="element-234">
          Back to Home
        </button>
      </div>;
  }
  // Find related products (same category, excluding current product)
  const relatedProducts = products.filter(p => p.category === product.category && p.id !== product.id).slice(0, 4);
  const handleAddToCart = () => {
    addToCart(product);
    setShowAddedMessage(true);
    setTimeout(() => setShowAddedMessage(false), 3000);
  };
  return <div className="bg-gray-50" data-id="element-235">
      <div className="container mx-auto px-4 py-8" data-id="element-236">
        {/* Back Button */}
        <button onClick={() => navigate(-1)} className="flex items-center text-gray-600 hover:text-green-600 mb-6" data-id="element-237">
          <ArrowLeftIcon size={18} className="mr-1" data-id="element-238" />
          Back
        </button>
        <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-239">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-6" data-id="element-240">
            {/* Product Image */}
            <div className="flex items-center justify-center" data-id="element-241">
              <img src={product.image} alt={product.name} className="max-w-full h-auto rounded-lg" data-id="element-242" />
            </div>
            {/* Product Details */}
            <div className="flex flex-col" data-id="element-243">
              <div className="mb-auto" data-id="element-244">
                <h1 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-245">
                  {product.name}
                </h1>
                <div className="flex items-center mb-4" data-id="element-246">
                  <span className="bg-green-50 text-green-700 text-xs px-2 py-1 rounded-full mr-2" data-id="element-247">
                    {product.category === 'electronics' ? 'Electronics' : 'Precious Metal'}
                  </span>
                  <span className="text-gray-500 capitalize" data-id="element-248">
                    {product.subcategory}
                  </span>
                </div>
                <div className="text-2xl font-bold text-green-600 mb-6" data-id="element-249">
                  ${product.price.toLocaleString()}
                </div>
                <div className="prose prose-sm text-gray-600 mb-8" data-id="element-250">
                  <p data-id="element-251">{product.description}</p>
                </div>
              </div>
              {/* Add to Cart Button */}
              <div className="mt-4" data-id="element-252">
                <div className="relative" data-id="element-253">
                  <button onClick={handleAddToCart} className="w-full py-3 px-6 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition flex items-center justify-center" data-id="element-254">
                    <ShoppingCartIcon size={20} className="mr-2" data-id="element-255" />
                    Add to Cart
                  </button>
                  {/* Added to Cart Message */}
                  {showAddedMessage && <div className="absolute top-0 left-0 right-0 -mt-12 bg-green-100 text-green-800 text-sm py-2 px-4 rounded-md flex items-center justify-center transition-opacity" data-id="element-256">
                      <CheckIcon size={16} className="mr-1" data-id="element-257" />
                      Added to cart!
                    </div>}
                </div>
                <button onClick={() => navigate('/cart')} className="w-full mt-3 py-3 px-6 bg-white text-green-600 font-medium rounded-lg hover:bg-gray-50 transition border border-green-600" data-id="element-258">
                  View Cart
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Related Products Section */}
        {relatedProducts.length > 0 && <div className="mt-16" data-id="element-259">
            <h2 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-260">
              Related Products
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-id="element-261">
              {relatedProducts.map(relatedProduct => <div key={relatedProduct.id} className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow" data-id="element-262">
                  <div className="aspect-square overflow-hidden cursor-pointer" onClick={() => navigate(`/product/${relatedProduct.id}`)} data-id="element-263">
                    <img src={relatedProduct.image} alt={relatedProduct.name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-300" data-id="element-264" />
                  </div>
                  <div className="p-4" data-id="element-265">
                    <h3 className="text-gray-800 font-medium mb-1 hover:text-green-600 transition cursor-pointer" onClick={() => navigate(`/product/${relatedProduct.id}`)} data-id="element-266">
                      {relatedProduct.name}
                    </h3>
                    <p className="text-green-600 font-semibold" data-id="element-267">
                      ${relatedProduct.price.toLocaleString()}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>}
      </div>
    </div>;
}